/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    GetUsersParams,
    OrganizationMemberResponse,
    PagedResponseOrganizationMemberResponse,
    UserCreateRequest,
    UserResponse,
    UserUpdateRequest
} from '../models';

export type getMyUserResponse200 = {
    data: UserResponse;
    status: 200;
};

export type getMyUserResponse400 = {
    data: void;
    status: 400;
};

export type getMyUserResponse500 = {
    data: void;
    status: 500;
};

export type getMyUserResponseSuccess = getMyUserResponse200 & {
    headers: Headers;
};

export type getMyUserResponseError = (getMyUserResponse400 | getMyUserResponse500) & {
    headers: Headers;
};

export type getMyUserResponse = getMyUserResponseSuccess | getMyUserResponseError;

export const getGetMyUserUrl = () => `/api/v1/users/me`;

export const getMyUser = async (options?: RequestInit): Promise<getMyUserResponse> => {
    const res = await fetch(getGetMyUserUrl(), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getMyUserResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getMyUserResponse;
};

export type updateMyUserResponse200 = {
    data: UserResponse;
    status: 200;
};

export type updateMyUserResponse400 = {
    data: void;
    status: 400;
};

export type updateMyUserResponse500 = {
    data: void;
    status: 500;
};

export type updateMyUserResponseSuccess = updateMyUserResponse200 & {
    headers: Headers;
};

export type updateMyUserResponseError = (updateMyUserResponse400 | updateMyUserResponse500) & {
    headers: Headers;
};

export type updateMyUserResponse = updateMyUserResponseSuccess | updateMyUserResponseError;

export const getUpdateMyUserUrl = () => `/api/v1/users/me`;

export const updateMyUser = async (
    userUpdateRequest: UserUpdateRequest,
    options?: RequestInit
): Promise<updateMyUserResponse> => {
    const res = await fetch(getUpdateMyUserUrl(), {
        ...options,
        body: JSON.stringify(userUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateMyUserResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateMyUserResponse;
};

export type getUsersResponse200 = {
    data: PagedResponseOrganizationMemberResponse;
    status: 200;
};

export type getUsersResponse400 = {
    data: void;
    status: 400;
};

export type getUsersResponse500 = {
    data: void;
    status: 500;
};

export type getUsersResponseSuccess = getUsersResponse200 & {
    headers: Headers;
};

export type getUsersResponseError = (getUsersResponse400 | getUsersResponse500) & {
    headers: Headers;
};

export type getUsersResponse = getUsersResponseSuccess | getUsersResponseError;

export const getGetUsersUrl = (params?: GetUsersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort', 'roles'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/users?${stringifiedParams}` : `/api/v1/users`;
};

export const getUsers = async (
    params?: GetUsersParams,
    options?: RequestInit
): Promise<getUsersResponse> => {
    const res = await fetch(getGetUsersUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getUsersResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getUsersResponse;
};

export type createResponse201 = {
    data: UserResponse;
    status: 201;
};

export type createResponse400 = {
    data: void;
    status: 400;
};

export type createResponse500 = {
    data: void;
    status: 500;
};

export type createResponseSuccess = createResponse201 & {
    headers: Headers;
};

export type createResponseError = (createResponse400 | createResponse500) & {
    headers: Headers;
};

export type createResponse = createResponseSuccess | createResponseError;

export const getCreateUrl = () => `/api/v1/users`;

export const create = async (
    userCreateRequest: UserCreateRequest,
    options?: RequestInit
): Promise<createResponse> => {
    const res = await fetch(getCreateUrl(), {
        ...options,
        body: JSON.stringify(userCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createResponse;
};

export type getUserByIdResponse200 = {
    data: OrganizationMemberResponse;
    status: 200;
};

export type getUserByIdResponse400 = {
    data: void;
    status: 400;
};

export type getUserByIdResponse500 = {
    data: void;
    status: 500;
};

export type getUserByIdResponseSuccess = getUserByIdResponse200 & {
    headers: Headers;
};

export type getUserByIdResponseError = (getUserByIdResponse400 | getUserByIdResponse500) & {
    headers: Headers;
};

export type getUserByIdResponse = getUserByIdResponseSuccess | getUserByIdResponseError;

export const getGetUserByIdUrl = (id: string) => `/api/v1/users/${id}`;

export const getUserById = async (
    id: string,
    options?: RequestInit
): Promise<getUserByIdResponse> => {
    const res = await fetch(getGetUserByIdUrl(id), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getUserByIdResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getUserByIdResponse;
};

export type _deleteResponse204 = {
    data: void;
    status: 204;
};

export type _deleteResponse400 = {
    data: void;
    status: 400;
};

export type _deleteResponse500 = {
    data: void;
    status: 500;
};

export type _deleteResponseSuccess = _deleteResponse204 & {
    headers: Headers;
};

export type _deleteResponseError = (_deleteResponse400 | _deleteResponse500) & {
    headers: Headers;
};

export type _deleteResponse = _deleteResponseSuccess | _deleteResponseError;

export const getDeleteUrl = (id: string) => `/api/v1/users/${id}`;

export const _delete = async (id: string, options?: RequestInit): Promise<_deleteResponse> => {
    const res = await fetch(getDeleteUrl(id), {
        ...options,
        method: 'DELETE'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: _deleteResponse['data'] = body ? JSON.parse(body) : undefined;

    return { data, headers: res.headers, status: res.status } as _deleteResponse;
};
